module.exports = __webpack_public_path__ + "img/big-picture-thinker.7511eef3.svg";